<template>
  <div>
    <base-card :loading="loading" class="rounded-lg pb-2">
      <div
        class="d-flex justify-center text--disabled align-center gap-1 pt-1 unselectable"
      >
        <small class="lh-1">
          {{ platform?.name || "Carregando..." }}
        </small>
      </div>
      <v-tabs v-model="tab" show-arrows class="rounded-lg" height="36px">
        <v-tab
          v-for="tab in !platform ? [] : tabsFiltered"
          class="rounded-lg"
          :key="tab.component"
        >
          <v-icon left small>{{ tab.icon }}</v-icon>
          {{ tab.name }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" :touchless="tabsFiltered[tab]?.touchless">
        <v-tab-item
          v-for="item in !platform ? [] : tabsFiltered"
          :key="item.name"
          class="pa-4"
        >
          <component
            :is="item.component"
            :platform="platform"
            @refresh="loadPlatform"
          />
        </v-tab-item>
      </v-tabs-items>
    </base-card>

    <!-- Navgation  -->
    <v-bottom-sheet
      v-model="navigationSheet"
      inset
      max-width="550px"
      :overlay-opacity="0.8"
      content-class="elevation-0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          dark
          style="position: fixed; bottom: 76px; right: 16px; z-index: 5"
          float
          v-bind="attrs"
          v-on="on"
          color="primary"
        >
          <v-icon> mdi-dots-grid </v-icon>
        </v-btn>
      </template>
      <div class="mb-4 px-4 d-flex w-full">
        <v-card class="pa-3 pb-1 rounded-lg w-full">
          <v-row dense class="mx-0">
            <v-col
              v-for="tab in tabsFiltered"
              :key="tab?.id"
              cols="4"
              sm="4"
              md="3"
            >
              <v-card
                @click="selectTab(tab?.id)"
                outlined
                height="90px"
                elevation="0"
                class="pa-2"
              >
                <div
                  class="d-flex align-center justify-center flex-column h-full text-center lh-1 gap-2"
                >
                  <v-icon>{{ tab.icon }}</v-icon>
                  {{ tab.name }}
                </div>
              </v-card>
            </v-col>
          </v-row>
          <div class="d-flex justify-center">
            <v-btn @click="navigationSheet = false" text small> Fechar </v-btn>
          </div>
        </v-card>
      </div>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import platformService from "@/services/admin/platform";
import PlatformDesign from "@/components/admin/platform/PlatformDesign.vue";
import PlatformGateway from "@/components/admin/platform/PlatformGateway.vue";
import PlatformCategories from "@/components/admin/platform/PlatformCategories.vue";

export default {
  metaInfo() {
    return { title: `⚙️ ${this.platform?.name || "Carregando..."}` };
  },
  data: () => ({
    loading: true,
    platform: null,
    tab: null,
    navigationSheet: false,
    tabs: [
      {
        id: "design",
        name: "Design",
        component: "PlatformDesign",
        icon: "mdi-palette",
      },
      {
        id: "categories",
        name: "Categorias",
        component: "PlatformCategories",
        icon: "mdi-tag-multiple",
        permission: 256,
      },
      {
        id: "gateway",
        name: "Gateway Pagamento",
        component: "PlatformGateway",
        icon: "mdi-server",
        permission: 67108864,
      },
    ],
  }),
  methods: {
    async loadPlatform() {
      try {
        this.loading = true;
        this.platform = await platformService.getById(this.$route.params.id);
        this.loading = false;
        this.tab = 0;
        this.selectTab();
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    copyDomain() {
      navigator.clipboard.writeText(this.platform.domain);
      this.$toast.success("Domínio copiado para a área de transferência");
    },
    selectTab(tab) {
      if (tab) window.location.replace("#" + tab);
      if (this.$route.hash) {
        let hash = tab || this.$route.hash.replace("#", "");
        let index = this.tabsFiltered.findIndex((tab) => tab?.id == hash);
        if (index >= 0) this.tab = index;
        this.navigationSheet = false;
      }
    },
    vibrate() {
      if (navigator.vibrate) navigator.vibrate(50);
    },
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    ...mapGetters("auth", ["hasPermission"]),
    tabsFiltered() {
      return this.tabs.filter(
        (tab) => !tab.permission || this.hasPermission(tab.permission)
      );
    },
  },
  watch: {
    tab: {
      handler(val, oldVal) {
        if (val !== null && oldVal !== null) this.vibrate();
        let tab = this.tabsFiltered[val];
        if (tab) window.location.replace("#" + tab?.id);
      },
      immediate: true,
    },
    "$route.hash"() {
      this.selectTab();
    },
    "selectedCompany.id"() {
      this.$router.push({
        name: "admin.platforms",
      });
    },
  },
  components: {
    PlatformDesign,
    PlatformGateway,
    PlatformCategories,
  },
  destroyed() {},
  mounted() {
    this.loadPlatform();
  },
};
</script>

<style></style>
